export const dailyHabitTracker = {
  name: "Daily Habit Tracker",
  excerpt: "Keep up with your habit goals",
  image: "simpleLeadTracker.webp",
  localUrl: "daily-habit-tracker",
  url: "https://www.simpleadtracker.com",
  description: "Daily Habit Tracker is a mobile app that allows users to create and track daily habits. The is designed to encourage hitting your habit each day, and building it long term.",
  challenge: "The main goal was to make it very quick and easy to track your habits each day. The app should stay out the way, and be as frictionless as possible to use. It should also be readily available, and able to be used anywhere at anytime.",
  solution: "Our end solution was a mobile app that make it simple to track your habit each day. We bring you right to the good stuff with the first button your presented with letting you mark the habit as done.",
  tech: ["Clojurescript", "Cordova", "MySqlLite"],
  images: ["simpleLeadTracker.webp", "simpleLeadTracker.webp", "simpleLeadTracker.webp"]
}
